import { Navigate } from 'react-router-dom'

import { CompanyDocumentsRouteDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import {
  canSeeEmployeeFilesTab,
  canSeeInternalFilesTab,
  canSeePublicFilesTab,
  canSeeSendInBulkTab,
  canSeeTemplatesTab,
  canSeeTrashTab,
} from 'modules/documents/routes'

const RedirectToFirstAvailableFilesTab = () => {
  const { navigation } = useNavigation()
  const { data } = useQuery(CompanyDocumentsRouteDocument, {
    variables: { byTrashBin: true },
  })

  if (!data) {
    return null
  }

  if (canSeePublicFilesTab(data)) {
    return <Navigate replace to={navigation.files.companyFiles.list.fullPath()} />
  }

  if (canSeeInternalFilesTab(data)) {
    return <Navigate replace to={navigation.files.managementDocuments.list.fullPath()} />
  }

  if (canSeeEmployeeFilesTab(data)) {
    return <Navigate replace to={navigation.files.employeeFiles.list.fullPath()} />
  }

  if (canSeeSendInBulkTab(data)) {
    return <Navigate replace to={navigation.files.bulkFiles.fullPath()} />
  }

  if (canSeeTemplatesTab(data)) {
    return <Navigate replace to={navigation.files.documentTemplates.fullPath()} />
  }

  if (canSeeTrashTab(data)) {
    return <Navigate replace to={navigation.files.trash.fullPath()} />
  }

  return <Navigate replace to={navigation.files.companyFiles.list.fullPath()} />
}

export default RedirectToFirstAvailableFilesTab
